import React from 'react'
import '../Styles/DeafCampPage1.scss';

function DeafCampPage1() {
   return (
      <div className="deafCampPage1Content">
         <div className="deafCampPage1Container">
            <div className="deafCampPage1Title">
               Deaf Camp
            </div>
            <div div className="deafCampPage1Description">
               Deaf campers have had the opportunity<br></br>
               to hear the gospel in sign language and <br></br>
               fellowship with each other here at camp <br></br>
               for over sixty years.
            </div>
            <div className="deafCampPage1WeeksContainer">
               <div className="deafCampPage1Weeks">
                  <div className="deafCampWeek1">
                     <div className="deafWeek1Title">
                        Week One
                     </div>
                     <div className="deafWeek1Content">
                        June 12 - June 16, 2023
                     </div>
                  </div>

                  <div className="vl"></div>

                  <div className="deafCampWeek2">
                     <div className="deafWeek2Title">
                        Week Two
                     </div>
                     <div className="deafWeek2Content">
                        June 26 - June 30, 2023
                     </div>
                  </div>

                  <div className="vl"></div>

                  <div className="deafCampWeek3">
                     <div className="deafWeek3Title">
                        Week Three
                     </div>
                     <div className="deafWeek3Content">
                        July 10 - July 14th 2023
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}
export default DeafCampPage1;